// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChatRoomPage_wrapper__15OVi","main":"ChatRoomPage_main__2VOYR","chatRoomLayout":"ChatRoomPage_chatRoomLayout__1gQYS"};